/**
 * Classic NumericInput spinner enhancement.
 * Hides native browser arrows on <input type="number"> (outside .input-spinner-wrap)
 * and injects custom up/down buttons with tinted background + chevron SVGs.
 * Runs on DOM mutations so dynamically-added inputs (modals, lazy sections) are covered.
 */

const ARROW_UP_SVG = `<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 4.5L5 1.5L8.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const ARROW_DOWN_SVG = `<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.5L5 4.5L8.5 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const MARKER_ATTR = 'data-iu-spinner';

function enhanceInput(input: HTMLInputElement) {
	if (input.hasAttribute(MARKER_ATTR)) return;
	if (input.closest('.input-spinner-wrap')) return;

	// Enhance inputs inside PowerDuck NumericInput's .input-group.maxwidth-input
	// OR standalone number inputs inside the edit-ticket-number modal
	const ig = input.closest('.input-group.maxwidth-input') || input.closest('.form-group.maxwidth-input');
	const inModal = input.closest('.modal-editticketnumber');
	if (!ig && !inModal) return;

	input.setAttribute(MARKER_ATTR, '1');
	input.classList.add('iu-num-input');

	const wrapper = document.createElement('div');
	wrapper.className = 'iu-num-arrows';

	const btnUp = document.createElement('button');
	btnUp.type = 'button';
	btnUp.tabIndex = -1;
	btnUp.className = 'iu-num-arrow iu-num-arrow-up';
	btnUp.innerHTML = ARROW_UP_SVG;
	btnUp.addEventListener('mousedown', (e) => { e.preventDefault(); });
	btnUp.addEventListener('click', () => {
		input.stepUp();
		input.dispatchEvent(new Event('change', { bubbles: true }));
	});

	const btnDown = document.createElement('button');
	btnDown.type = 'button';
	btnDown.tabIndex = -1;
	btnDown.className = 'iu-num-arrow iu-num-arrow-down';
	btnDown.innerHTML = ARROW_DOWN_SVG;
	btnDown.addEventListener('mousedown', (e) => { e.preventDefault(); });
	btnDown.addEventListener('click', () => {
		input.stepDown();
		input.dispatchEvent(new Event('change', { bubbles: true }));
	});

	wrapper.appendChild(btnUp);
	wrapper.appendChild(btnDown);

	// Insert right after the input (before any append-icon sibling)
	input.insertAdjacentElement('afterend', wrapper);
}

function scanAndEnhance() {
	document.querySelectorAll<HTMLInputElement>(
		'input[type="number"].form-control:not([data-iu-spinner])'
	).forEach((input) => {
		if (!input.closest('.input-spinner-wrap')) {
			enhanceInput(input);
		}
	});
}

// Initial scan
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', scanAndEnhance);
} else {
	scanAndEnhance();
}

// Watch for dynamically-added inputs (modals, lazy sections)
const observer = new MutationObserver(() => {
	scanAndEnhance();
});
observer.observe(document.body, { childList: true, subtree: true });
